import React from 'react';
import {useForm} from 'react-hook-form';
import {useSearchParams} from 'react-router-dom';
import {t} from '@lingui/core/macro';

import {zoneAPI} from 'features/admin/api/zoneAPI';
import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import Select from 'shared/ui/Select/Select';
import ListFiltersForm from 'shared/ui/Modal/ListFiltersForm/ListFiltersForm';
import {IFiltersFormComponentProps} from 'shared/ui/Modal/ListFiltersModal/ListFiltersModal';

interface ICitiesFiltersForm {
    zone?: string,
}

const CitiesFiltersForm: React.FC<IFiltersFormComponentProps> = ({onClose}) => {
    const [searchParams] = useSearchParams();
    const {data: zones = []} = zoneAPI.useGetZonesQuery();

    const {handleSubmit, control} = useForm<ICitiesFiltersForm>({
        defaultValues: {
            zone: searchParams.get('country.zone.id') ?? undefined,
        },
    });

    const zoneOptions = zones.map(zone => ({label: zone.name, value: String(zone.id)}));

    const toFilters = ({zone}: ICitiesFiltersForm) => ({
        'country.zone.id': zone ?? undefined,
    });

    return (
        <ListFiltersForm handleSubmit={handleSubmit} toFilters={toFilters} onClose={onClose}>
            <FormGroupWithError label={t`Зона`}>
                <Select control={control} name="zone" data={zoneOptions} cleanable={true} searchable={false}/>
            </FormGroupWithError>
        </ListFiltersForm>
    );
};

export default CitiesFiltersForm;
